import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/adobe': {
    width: 460,
    height: 512,
    paths: [
      {
        d: 'M289.9 64.3H460.8V448.3L289.9 64.3zM170.9 64.3H0V448.3L170.9 64.3zM230.4 206.4L337.9 448.3H264.9L234.2 371.5H155.5L230.4 206.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/adobe.js
// module id = qHZX
// module chunks = 144